export const COMMON_NR_EVENTS = {
  indStocksApiRequest: 'indstocks_api_request',
  indStocksFetchError: 'indstocks_get_fetch_error',
  indStocksFetchThrownError: 'indstocks_get_fetch_thrown_error',
  indStocksPostFetchError: 'indstocks_post_fetch_error',
  indStocksPostThrownFetchError: 'indstocks_post_thrown_fetch_error',
  indStocksFlashBottomError: 'indstocks_flash_bottom_error',
}

export const API_TYPES = {
  getUserData: 'GET_USER_DATA',
  getUserStateHash: 'GET_USER_STATE_HASH',
  getPortfolioSummary: 'GET_PORTFOLIO_SUMMARY',
  getVyaparOnboardStatus: 'GET_VYAPAR_ONBOARD_STATUS',

  getTradeScreen: 'GET_TRADE_SCREEN',
  getEntityDetails: 'GET_ENTITY_DETAILS',
  getEntityInfo: 'GET_ENTITY_INFO',
  getCatalogListing: 'GET_CATALOG_LISTING',
  getIpoList: 'GET_IPO_LIST',
  getFnoOrders: 'GET_FNO_ORDERS',
  getCatalogIndicesData: 'GET_CATALOG_INDICES_DATA',

  buyOrder: 'BUY_ORDER',
  sellOrder: 'SELL_ORDER',

  getCandles: 'GET_CANDLES',
  getV2Candles: 'GET_V2_CANDLES',

  // Flash Trading
  getFlashInstrumentInfo: 'GET_FLASH_INSTRUMENT_INFO',
  getWalletData: 'GET_WALLET_DATA',
  getExitPositionsData: 'GET_EXIT_POSITIONS_DATA',
  instantExit: 'INSTANT_EXIT',
  chartsInstantExit: 'CHARTS_INSTANT_EXIT',
  buyTrade: 'BUY_TRADE',
  getPositions: 'GET_POSITIONS',
  cancelOrder: 'CANCEL_ORDER',
  flashExitPositions: 'FLASH_EXIT_POSITIONS',
  getHashedToken: 'GET_HASHED_TOKEN',
  getLegWisePnl: 'GET_LEG_WISE_PNL',

  lottie: 'LOTTIE',
  unspecified: 'UNSPECIFIED',

  watchlistV4Search: 'WATCHLIST_V4_SEARCH',
  jwtRefresh: 'JWT_REFRESH',
  getExperimentConfigData: 'GET_EXPERIMENT_CONFIG_DATA',

  // AUTH
  decryptSsoHandler: 'DECRYPT_SSO_HANDLER',
  refreshTokenApi: 'REFRESH_TOKEN_API',
} as const
